"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _routeMatch = require("../../utils/routeMatch");
var _SocketEvents = require("../../constants/SocketEvents");
var _types = require("../../actions/sessionState/types");
function sessionStateEmitter(socket) {
  return function (store) {
    return function (next) {
      return function (action) {
        var targetAction = _types.BROADCAST_SET_SESSION_STATE;
        (0, _rxjs.from)([action]).pipe((0, _operators.filter)(function ($action) {
          return targetAction === $action.type;
        })).subscribe(function ($action) {
          var sessionState = $action.payload;
          var routeMatch = (0, _routeMatch.getBroadcastRouteMatch)(store.getState);
          if (!routeMatch) return;
          var broadcastId = routeMatch.params.broadcastId;
          socket.emit(_SocketEvents.SESSION_STATE_CHANGE, {
            broadcastId: broadcastId,
            sessionState: sessionState
          });
        });
        return next(action);
      };
    };
  };
}
var _default = exports["default"] = sessionStateEmitter;